import React from 'react'

import PropTypes from 'prop-types'
import { setPropTypes } from 'recompose'
import { Route } from 'react-router-dom'

const LazyRoute = ({ component: Component, ...props }) => (
  <Route {...props} render={routeProps => <Component {...routeProps} {...props} />} />
)

const enhance = setPropTypes({
  component: PropTypes.any.isRequired
})

export default enhance(LazyRoute)
